module.exports = __webpack_public_path__ + "static/media/Fondo@2x.6739b4f0.png";